import React, { useCallback } from 'react';
import { setRowPropAction } from '../../../../../redux/slices/oldBuilder';
import CohortRowAnalysisMenu from '../CohortRowAnalysisMenu';
import { QueryType } from '../../../../../utils/apollo/graphqlSchema';
import BuilderTimeWindow from '../BuilderTimeWindow';
import { CohortRowContent, CohortRowRelatedInfo } from '../CohortRowUI';
import ExpressionMeasureMenu from '../../../../ExpressionMeasureMenu';
import { useAppDispatch } from '../../../../../redux/hooks';
import { useCohortRowContext } from '../CohortRowContext';
import useAnalysisBuilderInfo from '../../../../../redux/selectorHooks/useAnalysisBuilderInfo';
import isNil from 'lodash/isNil';
import { CohortRowOperators } from '../CohortRowOperators';

const ExpressionCohort = () => {
  const dispatch = useAppDispatch();
  const { rowMeta, cohortRow } = useCohortRowContext();

  const selectedAnalysisId = cohortRow?.analysisId;
  const analysisBuilderInfo = useAnalysisBuilderInfo(selectedAnalysisId);
  const builderInfo = analysisBuilderInfo?.query;

  const onMeasureChange = useCallback(
    (measureId: string) => {
      dispatch(
        setRowPropAction({
          rowMeta,
          row: { ...cohortRow, measureId },
        }),
      );
    },
    [cohortRow, dispatch, rowMeta],
  );

  return (
    <CohortRowContent>
      <CohortRowRelatedInfo>
        <CohortRowAnalysisMenu
          rowMeta={rowMeta}
          cohortRow={cohortRow}
          title={'Query'}
          queryType={QueryType.Expression}
        />
        {!isNil(builderInfo) && selectedAnalysisId && (
          <ExpressionMeasureMenu
            analysisId={selectedAnalysisId}
            measureId={cohortRow.measureId}
            onMeasureChange={onMeasureChange}
            aliasReplacements={cohortRow.aliasReplacements}
          />
        )}
        <CohortRowOperators />
      </CohortRowRelatedInfo>
      <BuilderTimeWindow />
    </CohortRowContent>
  );
};

export default ExpressionCohort;
